import { createReducer, on } from '@ngrx/store';
import {
  ManagementTokensVppApiActions,
  ManagementTokensDepApiActions,
  DepApiActions,
  ManagementTokensPushApiActions,
  PushApiActions,
  ManagementTokensVendorApiActions,
  VendorApiActions,
} from './management.actions';
import { adapter, initialState, managementTokensMeta } from './management.state';

export const ManagementTokensReducer = createReducer(
  initialState,
  on(
    ManagementTokensVppApiActions.managementVppTokenLoaded,
    ManagementTokensVppApiActions.managementVppTokenUpdated,
    (state, { payload }) =>
      adapter.upsertOne(
        {
          type: 'vpp',
          token: payload,
          ...managementTokensMeta.vpp,
        },
        state
      )
  ),
  on(
    ManagementTokensDepApiActions.managementDepTokenLoaded,
    DepApiActions.managementDepTokenUpdated,
    (state, { payload }) =>
      adapter.upsertOne(
        {
          type: 'dep',
          token: payload,
          ...managementTokensMeta.dep,
        },
        state
      )
  ),
  on(
    ManagementTokensPushApiActions.managementPushTokenLoaded,
    PushApiActions.managementPushTokenUpdated,
    (state, { payload }) =>
      adapter.upsertOne(
        {
          type: 'push',
          token: payload,
          ...managementTokensMeta.push,
        },
        state
      )
  ),
  on(
    ManagementTokensVendorApiActions.managementVendorTokenLoaded,
    VendorApiActions.managementVendorTokenUpdated,
    (state, { payload }) =>
      adapter.upsertOne(
        {
          type: 'vendor',
          token: payload,
          ...managementTokensMeta.vendor,
        },
        state
      )
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectManagementIds = selectIds;

export const selectManagementEntities = selectEntities;

export const selectAllManagementTokens = selectAll;
